if (Foundation.MOBILE) {
    /** @implements {Foundation.View.Interface.Spinner} */
    Foundation.View.Spinner = Foundation.View.Mobile.Spinner;
}
else {
    /** @implements {Foundation.View.Interface.Spinner} */
    Foundation.View.Spinner = Foundation.View.Desktop.Spinner;
}

